<template>
  <div id="commodityMgmtV2" style="margin: 0 auto; background: white">
    <div class="header-box">
      <div class="header-line">
        <span class="header-label">店铺</span>
        <el-select v-model="params.shopId" size="small" placeholder="请选择店铺" style="width: 140px">
          <el-option v-for="item in shopOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
        <span class="header-label">ASIN</span>
        <el-input placeholder="请输入ASIN" size="small" clearable v-model="params.asin"
                  style="width: 140px"></el-input>
        <span class="header-label">卖家名称</span>
        <el-input placeholder="请输入卖家名称" size="small" clearable v-model="params.shopName"
                  style="width: 140px"></el-input>
        <span class="header-label">品牌</span>
        <el-input placeholder="请输入品牌" size="small" clearable v-model="params.brand"
                  style="width: 120px"></el-input>
        <span class="header-label">版本</span>
        <el-input placeholder="如20260208" size="small" clearable v-model="params.version"
                  style="width: 120px"></el-input>
      </div>
      <div class="header-line">
        <el-button type="primary" size="small" @click="resetParams">重置</el-button>
        <el-button type="primary" size="small" @click="queryData">查询</el-button>
      </div>
    </div>

    <el-table
      :data="displayData"
      border
      size="mini"
      :height="screenHeight"
      style="width: 100%"
      :row-key="getRowKey"
      :span-method="spanMethod"
      :row-class-name="getRowClassName"
      cell-class-name="v2-table-cell"
    >
      <el-table-column width="30" align="center">
        <template v-slot="scope">
          <span v-if="scope.row._isMain" @click="toggleExpand(scope.row._productId)" class="expand-toggle">
            <i :class="isExpanded(scope.row._productId) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
          </span>
        </template>
      </el-table-column>

      <el-table-column label="序号" width="50" align="center">
        <template v-slot="scope">
          {{ (params.currentPage - 1) * params.pageSize + scope.row._index + 1 }}
        </template>
      </el-table-column>

      <el-table-column label="图片" width="60" align="center">
        <template v-slot="scope">
          <el-image :src="scope.row.image" style="height: 40px; width: 40px" fit="fill"></el-image>
        </template>
      </el-table-column>

      <el-table-column label="商品信息" min-width="220" show-overflow-tooltip>
        <template v-slot="scope">
          <div class="goods-name">{{ scope.row.name }}</div>
          <div class="goods-meta">
            ASIN: <span class="blue" @click="openAmazonPage(scope.row.asin)">{{ scope.row.asin }}</span>
            <i class="el-icon-document-copy copy-icon" @click="copyToClipboard(scope.row.asin)" title="复制ASIN"></i>
            | 父ASIN: <span class="blue" @click="openAmazonPage(scope.row.parentAsin)" v-if="scope.row.parentAsin">{{ scope.row.parentAsin }}</span>
            <i class="el-icon-document-copy copy-icon" @click="copyToClipboard(scope.row.parentAsin)" v-if="scope.row.parentAsin" title="复制父ASIN"></i>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="brand" label="品牌" width="90" align="center" show-overflow-tooltip></el-table-column>

      <el-table-column label="排名" width="70" align="center">
        <template v-slot="scope">
          <span :class="getRankClass(scope.row.rank)">{{ scope.row.rank != null ? scope.row.rank : '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="评论数" width="70" align="center">
        <template v-slot="scope">{{ scope.row.commentCount != null ? scope.row.commentCount : '-' }}</template>
      </el-table-column>

      <el-table-column label="价格" width="70" align="center">
        <template v-slot="scope">{{ scope.row.unitPrice != null ? scope.row.unitPrice : '-' }}</template>
      </el-table-column>

      <el-table-column label="评分" width="60" align="center">
        <template v-slot="scope">{{ scope.row.score != null ? scope.row.score : '-' }}</template>
      </el-table-column>

      <el-table-column label="增速" width="55" align="center">
        <template v-slot="scope">
          <div :class="getDifClass(scope.row.rankAverageDif)">{{ scope.row.rankAverageDif }}</div>
          <div :class="getDifClass(scope.row.commentAverageDif)">{{ scope.row.commentAverageDif }}</div>
        </template>
      </el-table-column>

      <el-table-column label="指标" width="55" align="center">
        <template v-slot="scope">
          <span :style="{ color: scope.row._metricColor, fontSize: '11px', fontWeight: 'bold' }">{{ scope.row._metricLabel }}</span>
        </template>
      </el-table-column>

      <el-table-column
        v-for="col in dateColumns"
        :key="col.version"
        :label="col.label"
        width="55"
        align="center"
      >
        <template v-slot="scope">
          <span :class="scope.row._metricType === 'rank' ? getRankClass(getHistoryField(scope.row, col.version, 'rank')) : ''">
            {{ getHistoryField(scope.row, col.version, scope.row._metricType) != null ? getHistoryField(scope.row, col.version, scope.row._metricType) : '-' }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100" align="center">
        <template v-slot="scope">
          <el-button type="text" size="mini" @click="goDetail(scope.row)">详情</el-button>
          <el-button type="text" size="mini" @click="openAddCompetitorDialog(scope.row)">添加竞品</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加竞品弹窗 -->
    <el-dialog title="添加竞品" :visible.sync="competitorDialog.visible" width="600px" :close-on-click-modal="false">
      <div class="competitor-dialog">
        <div class="shop-goods-info">
          <div class="info-title">当前商品：</div>
          <div class="info-content" v-if="competitorDialog.shopGoods">
            <div class="goods-basic">
              <el-image :src="competitorDialog.shopGoods.image" style="width: 60px; height: 60px" fit="fill"></el-image>
              <div class="goods-detail">
                <div class="goods-name">{{ competitorDialog.shopGoods.name }}</div>
                <div class="goods-asis">
                  ASIN: <span class="asin-link" @click="openAmazonPage(competitorDialog.shopGoods.asin)">{{ competitorDialog.shopGoods.asin }}</span>
                  <i class="el-icon-document-copy copy-icon" @click="copyToClipboard(competitorDialog.shopGoods.asin)" title="复制ASIN"></i>
                </div>
                <div class="goods-brand">品牌: {{ competitorDialog.shopGoods.brand }}</div>
              </div>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="search-section">
          <el-input placeholder="请输入竞品ASIN进行搜索" v-model="competitorDialog.searchAsin" size="small"
                    @keyup.enter.native="searchCompetitorGoods" clearable style="width: 300px">
            <el-button slot="append" icon="el-icon-search" @click="searchCompetitorGoods">搜索</el-button>
          </el-input>
        </div>
        <div class="search-result search-goods" v-if="competitorDialog.searchResult">
          <div class="goods-basic">
            <el-image :src="competitorDialog.searchResult.image" style="width: 60px; height: 60px" fit="fill"></el-image>
            <div class="goods-detail">
              <div class="goods-name search-result-name">{{ competitorDialog.searchResult.name }}</div>
              <div class="goods-asis">
                ASIN: <span class="asin-link" @click="openAmazonPage(competitorDialog.searchResult.asin)">{{ competitorDialog.searchResult.asin }}</span>
                <i class="el-icon-document-copy copy-icon" @click="copyToClipboard(competitorDialog.searchResult.asin)" title="复制ASIN"></i>
              </div>
              <div class="goods-brand">品牌: {{ competitorDialog.searchResult.brand }}</div>
              <div class="goods-shop">卖家: {{ competitorDialog.searchResult.shopName }}</div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="competitorDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="confirmAddCompetitor" :loading="competitorDialog.loading">确认添加</el-button>
      </span>
    </el-dialog>

    <el-pagination
      ref="pageNav"
      layout="total, prev, pager, next"
      background
      :page-size="params.pageSize"
      :total="total"
      :current-page.sync="params.currentPage"
      @current-change="onPageChange"
    ></el-pagination>
  </div>
</template>

<script>
import {goodsStatisticsModules} from "@r";

export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 90 - 50,
      params: {
        shopId: 1,
        asin: "",
        shopName: "",
        brand: "",
        version: "",
        currentPage: 1,
        pageSize: 20,
      },
      shopOptions: [
        { id: 1, name: "灵柚" },
        { id: 2, name: "利尔" },
        { id: 3, name: "臻昂" },
        { id: 4, name: "萧发" },
        { id: 5, name: "誉腾" },
      ],
      tableData: [],
      total: 0,
      dateColumns: [],
      expandedIds: [],
      competitorDialog: {
        visible: false,
        shopGoods: null,
        searchAsin: "",
        searchResult: null,
        loading: false
      },
    };
  },
  computed: {
    displayData: function () {
      var result = [];
      var self = this;
      this.tableData.forEach(function (item, idx) {
        var productId = item.id || item.asin;
        var expanded = self.expandedIds.indexOf(productId) >= 0;
        var rowspan = expanded ? 5 : 1;

        result.push(Object.assign({}, item, {
          _isMain: true,
          _rowspan: rowspan,
          _metricType: "rank",
          _metricLabel: "排名",
          _metricColor: "#5470c6",
          _index: idx,
          _productId: productId,
        }));

        if (expanded) {
          var metrics = [
            {key: "sales", label: "销量", color: "#91cc75"},
            {key: "comments", label: "评论数", color: "#fac858"},
            {key: "price", label: "价格", color: "#ee6666"},
            {key: "score", label: "评分", color: "#73c0de"},
          ];
          metrics.forEach(function (m) {
            result.push(Object.assign({}, item, {
              _isMain: false,
              _rowspan: 0,
              _metricType: m.key,
              _metricLabel: m.label,
              _metricColor: m.color,
              _index: idx,
              _productId: productId,
            }));
          });
        }
      });
      return result;
    }
  },
  mounted() {
    this.queryData();
    this.$eventBus.$on("resize", this.onResize);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.onResize);
  },
  methods: {
    queryData() {
      goodsStatisticsModules
        .page(this.params)
        .then(res => {
          if (res.code === "00000") {
            this.tableData = res.data.records || [];
            this.total = res.data.total || this.tableData.length;
            this.buildDateColumns();
          } else {
            this.$message({type: "error", message: res.msg || "查询失败"});
          }
        })
        .catch(err => {
          this.$message({type: "error", message: (err && err.msg) || "请求失败"});
        });
    },
    buildDateColumns() {
      if (this.tableData.length > 0 && this.tableData[0].goodsHistoryList) {
        var historyList = this.tableData[0].goodsHistoryList.slice();
        historyList.sort(function (a, b) {
          return b.version - a.version;
        });
        this.dateColumns = historyList.map(item => ({
          version: item.version,
          label: this.formatVersion(item.version),
        }));
      } else {
        this.dateColumns = [];
      }
    },
    getHistoryField(row, version, field) {
      if (!row.goodsHistoryList) return null;
      var item = row.goodsHistoryList.find(function (h) {
        return h.version === version;
      });
      return item ? item[field] : null;
    },
    formatVersion(version) {
      if (!version) return "";
      var str = String(version);
      return str.substring(4, 6) + "-" + str.substring(6, 8);
    },
    getRankClass(rank) {
      if (rank == null) return "";
      if (rank <= 10) return "rank-top";
      if (rank <= 100) return "rank-good";
      if (rank <= 500) return "rank-mid";
      return "";
    },
    getDifClass(val) {
      if (val > 0) return "dif-up";
      if (val < 0) return "dif-down";
      return "";
    },
    goDetail(row) {
      location.href = "/client/commodityMgmtV2/detail?asin=" + row.asin + "&shopId=" + (row.shopId || this.params.shopId);
    },
    resetParams() {
      this.params = {
        shopId: 1,
        asin: "",
        shopName: "",
        brand: "",
        version: "",
        currentPage: 1,
        pageSize: 20,
      };
      this.queryData();
    },
    onPageChange(page) {
      this.params.currentPage = page;
      this.queryData();
    },
    onResize() {
      this.screenHeight = document.body.clientHeight - 64 - 90 - 50;
    },
    toggleExpand(productId) {
      var idx = this.expandedIds.indexOf(productId);
      if (idx >= 0) {
        this.expandedIds.splice(idx, 1);
      } else {
        this.expandedIds.push(productId);
      }
    },
    isExpanded(productId) {
      return this.expandedIds.indexOf(productId) >= 0;
    },
    getRowKey(row) {
      return row._productId + "_" + row._metricType;
    },
    getRowClassName: function (obj) {
      if (!obj.row._isMain) return "metric-sub-row";
      return "";
    },
    spanMethod: function (obj) {
      var row = obj.row;
      var columnIndex = obj.columnIndex;
      // 指标列(index 10) 和 日期列(index 11 ~ 10+dateColumns.length) 不合并，每行独立
      var nonMergeStart = 10;
      var nonMergeEnd = 10 + this.dateColumns.length;

      if (columnIndex >= nonMergeStart && columnIndex <= nonMergeEnd) {
        return [1, 1];
      }

      // 其余列（左侧信息列 + 操作列）按产品合并
      if (row._isMain) {
        return [row._rowspan, 1];
      } else {
        return [0, 0];
      }
    },
    /**
     * 打开添加竞品弹窗
     */
    openAddCompetitorDialog(row) {
      this.competitorDialog.shopGoods = row;
      this.competitorDialog.searchAsin = "";
      this.competitorDialog.searchResult = null;
      this.competitorDialog.visible = true;
    },
    /**
     * 搜索竞品商品
     */
    searchCompetitorGoods() {
      if (!this.competitorDialog.searchAsin || this.competitorDialog.searchAsin.trim() === "") {
        this.$message({type: "warning", message: "请输入竞品ASIN"});
        return;
      }
      this.competitorDialog.loading = true;
      goodsStatisticsModules.searchByAsin({
        asin: this.competitorDialog.searchAsin.trim(),
        shopId: this.params.shopId
      }).then(res => {
        if (res.code === "00000") {
          this.competitorDialog.searchResult = res.data;
        } else {
          this.$message({type: "error", message: res.msg || "搜索失败"});
          this.competitorDialog.searchResult = null;
        }
      }).catch(err => {
        this.$message({type: "error", message: (err && err.msg) || "请求失败"});
        this.competitorDialog.searchResult = null;
      }).finally(() => {
        this.competitorDialog.loading = false;
      });
    },
    /**
     * 确认添加竞品
     */
    confirmAddCompetitor() {
      if (!this.competitorDialog.searchResult) {
        this.$message({type: "warning", message: "请先搜索并选择竞品"});
        return;
      }
      this.competitorDialog.loading = true;
      goodsStatisticsModules.addCompetitorRelation({
        shopAsin: this.competitorDialog.shopGoods.asin,
        competitorAsin: this.competitorDialog.searchResult.asin,
        shopId: this.params.shopId
      }).then(res => {
        if (res.code === "00000") {
          this.$message({type: "success", message: "添加竞品关联成功"});
          this.competitorDialog.visible = false;
        } else {
          this.$message({type: "error", message: res.msg || "添加失败"});
        }
      }).catch(err => {
        this.$message({type: "error", message: (err && err.msg) || "请求失败"});
      }).finally(() => {
        this.competitorDialog.loading = false;
      });
    },
    /**
     * 打开Amazon商品详情页
     */
    openAmazonPage(asin) {
      if (!asin) return;
      // 根据店铺ID判断Amazon站点
      let domain = 'www.amazon.com'; // 默认美国站
      if (this.params.shopId === 7) {
        // 日本Temu使用日本站
        domain = 'www.amazon.co.jp';
      }
      const url = `https://${domain}/dp/${asin}`;
      window.open(url, '_blank');
    },
    /**
     * 复制到剪贴板
     */
    copyToClipboard(text) {
      if (!text) return;
      // 创建临时input元素
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$message({type: 'success', message: '复制成功'});
      } catch (err) {
        this.$message({type: 'error', message: '复制失败'});
      }
      document.body.removeChild(input);
    }
  }
};
</script>

<style lang="scss">
#commodityMgmtV2 {
  .header-box {
    text-align: left;
    line-height: 30px;
    padding: 10px 10px 5px;

    .el-input,
    .el-select {
      width: 120px;
      margin-right: 15px;
      margin-left: 5px;
    }

    .el-button {
      width: 80px;
    }

    .header-line {
      margin-bottom: 10px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .header-label {
      font-size: 14px;
    }
  }

  .goods-name {
    font-size: 12px;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .goods-meta {
    font-size: 11px;
    color: #909399;
    margin-top: 2px;
  }

  .blue {
    color: #5893ff;
    cursor: pointer;
  }

  .asin-link {
    color: #5893ff;
    cursor: pointer;
    text-decoration: underline;
    &:hover {
      color: #409eff;
    }
  }

  .copy-icon {
    margin-left: 5px;
    color: #909399;
    cursor: pointer;
    font-size: 12px;
    &:hover {
      color: #409eff;
    }
  }

  .rank-top {
    color: #e6a23c;
    font-weight: bold;
  }

  .rank-good {
    color: #67c23a;
    font-weight: bold;
  }

  .rank-mid {
    color: #409eff;
  }

  .dif-up {
    color: #f56c6c;
  }

  .dif-down {
    color: #67c23a;
  }

  .expand-toggle {
    cursor: pointer;
    font-size: 12px;
    color: #606266;

    &:hover {
      color: #409eff;
    }
  }

  .v2-table-cell {
    padding: 2px 0 !important;

    .cell {
      padding: 0 4px !important;
    }
  }

  .el-table {
    .metric-sub-row {
      background: #f9f9fb !important;

      td {
        background: #f9f9fb !important;
      }
    }
  }

  .el-pagination {
    margin-top: 10px;
    text-align: right;
    padding: 5px 10px;
  }

  .competitor-dialog {
    .shop-goods-info {
      margin-bottom: 15px;
      .info-title {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 10px;
        color: #303133;
      }
      .goods-basic {
        display: flex;
        align-items: flex-start;
        gap: 15px;
        .goods-detail {
          flex: 1;
          .goods-name {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 5px;
            color: #303133;
            white-space: normal;
            word-break: break-word;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
          }
          .goods-asis,
          .goods-brand {
            font-size: 12px;
            color: #606266;
            margin-top: 3px;
          }
        }
      }
    }
    .search-section {
      margin: 20px 0;
    }
    .search-result {
      margin-top: 20px;
      padding: 15px;
      background: #f5f7fa;
      border-radius: 4px;
      .goods-basic {
        display: flex;
        align-items: flex-start;
        gap: 15px;
        .goods-detail {
          flex: 1;
          .goods-asis,
          .goods-brand,
          .goods-shop {
            font-size: 12px;
            color: #606266;
            margin-top: 3px;
          }
        }
      }
    }
    .search-result-name {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 5px;
      color: #303133;
      white-space: normal;
      word-break: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      max-width: 100%;
    }
  }
}
</style>
